import {
  any, boolean, date, dateMinute,
  nullable, string,
} from '@sda/sdk/helpers/types.bitmasks';

export const PrivateRequestMask = {
  showId: string,
  hasScheduledPreRecording: boolean | nullable,
  isRejected: boolean,
  rejectedAt: date | nullable,
  rejectedBy: string | nullable,

  isApproved: boolean,
  owner: string | nullable,

  startTime: dateMinute | nullable,
  endTime: dateMinute | nullable,
  publicShow: any | nullable,
  publicUser: any | nullable,

  createdAt: date,
  updatedAt: date,
};
